(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mothers-day-faq-accordian"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaq(list) {
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.faq-acc__q');
      if (!btn) return;
      var item = btn.parentElement;
      var ans = item.querySelector('.faq-acc__a');
      var isOpen = item.classList.toggle('faq-acc__item--open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      ans.style.maxHeight = isOpen ? ans.scrollHeight + 'px' : '0';
    });
  }

  document.querySelectorAll('.faq-acc__list').forEach(initFaq);
})();

  } catch(e) { console.error(e); }
})();
})();
